import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from 'app/services/app/app.service';

@Component({
  selector: 'app-toasts',
  templateUrl: './toast.component.html',
  standalone: true,
	imports: [NgbToastModule, NgIf, NgTemplateOutlet, NgFor],
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  
  constructor(public appService: AppService) { 

  }
  
  isTemplate(toast) {
		return toast.textOrTpl instanceof TemplateRef;
	}
  

}
